<footer id="footer" class="d-flex flex-column justify-content-center">
    <div class="logoEni mx-auto">
        <img src="/logoEnisaEOI.webp" [attr.alt]="'footer.logo_alt' | translate" width="500" height="100"
            class="img-fluid" loading="lazy">
    </div>

    <ul class="list-unstyled d-flex justify-content-center align-items-center flex-wrap">
        <li>
            <a [routerLink]="routeHelper.buildRoute('privacy-policy')">{{ 'footer.privacy_policy' | translate
                }}</a>
        </li>
        <li>
            <a [routerLink]="routeHelper.buildRoute('cookies-policy')">{{ 'footer.cookies_policy' | translate }}</a>
        </li>
        <li>
            <a [routerLink]="routeHelper.buildRoute('terms-conditions')">{{ 'footer.terms_conditions' | translate }}</a>
        </li>
        <li>
            <a [routerLink]="routeHelper.buildRoute('dpa')">{{ 'footer.dpa' | translate }}</a>
        </li>
    </ul>

    <ul class="secondrow list-unstyled d-flex justify-content-center align-items-center flex-wrap">
        <li>{{ 'footer.copyright' | translate: {year: year} }}</li>
        <li class="sep">|</li>
        <li>{{ 'footer.rights' | translate }}</li>
        <li class="sep">|</li>
        <li>{{ 'footer.gdpr' | translate }}</li>
        <li class="sep">|</li>
        <li>
            <a [routerLink]="routeHelper.buildRoute('privacy-policy')">{{ 'footer.legal_notice' | translate }}</a>
        </li>
    </ul>
</footer>
